import { FETCH_VM_FEEDBACKS } from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const vmFeedbacksReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VM_FEEDBACKS:
      return { list: action.payload, others: action.others };
    default:
      return state;
  }
};

export default vmFeedbacksReducer;
